import moment from "moment";
import CryptoJS from "crypto-js";
import { FREQUENCY_TYPES, HOUSEHOLD_TYPES_NAME, StorageConstants } from "../constants/Constants";
import { Routes } from "../constants/RouteConstants";
import { Config } from "../config/Config";


const ENCODE_SECRET_KEY_1 = '#&*BB&G*&#&*#G8754454^&*T*&GMAN&^#$$ISH883782&**78';
const ENCODE_SECRET_KEY_2 = 'FDCC^%RD%T&ST(**&YGB^$EDECW$SEDCDYVE@F&@^TV^&A^CVA';
const ENCODE_SECRET_KEY_3 = '&^RFVWB&^&*^RD^DF^RG&*ABEVSAS!@#$W#SA$##$#$@####@@';

export const saveToStorage = ({ key, value, type = 'local', isSecure = true }: {
    key: string,
    value: any,
    type?: 'local' | 'session',
    isSecure?: boolean
}) => {
    let newValue = JSON.stringify(value);
    if (isSecure) {
        newValue = encodeData(newValue);
    }
    if (typeof window !== 'undefined') {
        if (type === 'local') {
            localStorage.setItem(key, newValue);
        } else if (type === 'session') {
            sessionStorage.setItem(key, newValue);
        }
    }
};

export const getFromStorage = ({ key, type = 'local', isSecure = true }: {
    key: string,
    type?: 'local' | 'session',
    isSecure?: boolean,
}) => {
    let value: any = null;
    if (typeof window !== 'undefined') {
        if (type === 'local') {
            value = localStorage.getItem(key)
        } else if (type === 'session') {
            value = sessionStorage.getItem(key)
        }
    }
    if (isSecure) {
        // value = decodeData(value);
        try {
            value = decodeData(value);
        } catch (error) {
            console.error("Error during decryption:", error);
            return null;
        }
    }
    return isJson(value) ? JSON.parse(value) : value;
};

export const deleteFromStorage = ({ key, type = 'local' }: {
    key: string,
    type?: 'local' | 'session',
}) => {
    if (typeof window !== 'undefined') {
        if (type === 'local') {
            if (key) {
                localStorage.removeItem(key)
            } else {
                localStorage.clear()
            }
        } else if (type === 'session') {
            if (key) {
                sessionStorage.removeItem(key)
            } else {
                sessionStorage.clear()
            }
        }
    }
};

export const encodeData = (value: any) => {
    if (value != null && value != undefined && value != 'undefined') {
        const encryptedData = CryptoJS.AES.encrypt(value.toString(), ENCODE_SECRET_KEY_1).toString();
        const encryptedData2 = CryptoJS.AES.encrypt(encryptedData.toString(), ENCODE_SECRET_KEY_2).toString();
        const encryptedDataMain = CryptoJS.AES.encrypt(encryptedData2.toString(), ENCODE_SECRET_KEY_3).toString();
        return encryptedDataMain?.replaceAll("/", "Enc@de");
    } else {
        return value;
    }
}

export const decodeData = (value: any) => {
    if (value && typeof value === 'string') {
        const replaceddata: any = value?.replaceAll("Enc@de", "/");
        const decryptedData1 = CryptoJS.AES.decrypt(replaceddata.toString(), ENCODE_SECRET_KEY_3).toString(CryptoJS.enc.Utf8);
        const decryptedData2 = CryptoJS.AES.decrypt(decryptedData1.toString(), ENCODE_SECRET_KEY_2).toString(CryptoJS.enc.Utf8);
        const decryptedDataMain = CryptoJS.AES.decrypt(decryptedData2.toString(), ENCODE_SECRET_KEY_1).toString(CryptoJS.enc.Utf8);
        return decryptedDataMain;
    } else {
        return value;
    }
}

export const isAuthenticated = () => {
    const token = getFromStorage({ key: StorageConstants?.ACCESS_TOKEN });
    if (token) {
        return token
    } return false
}
export const pluck = (array: string[] | object[], key: any) => {
    if (array?.length > 0) {
        return array.map((arr: any) => arr[key]);
    } else {
        return array;
    }
}

export const isJson = (str: any) => {
    try {
        JSON.parse(str);
    } catch (e) {
        return false;
    }
    return true;
}

export const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const handleLogout = (navigate: any = null) => {
    deleteFromStorage({ key: StorageConstants?.ACCESS_TOKEN });
    deleteFromStorage({ key: StorageConstants?.USER_DETAIL });
    deleteFromStorage({ key: StorageConstants?.DASHBOARD, type: 'session' });
    // window.location.href = Routes?.Login;
    if (navigate) {
        navigate(Routes?.Login)
    } else {
        window.location.href = Config?.BASE_URL + Routes?.Login;
    }
}

export const renderFormData = (values: any) => {
    var formData = new FormData();
    Object.keys(values).map(function (key) {
        formData.append(key, values[key])
    });
    return formData
}

export const getDateHelper = ({ date, format = 'YYYY-MM-DD', type }: any) => {
    // export const getDateHelper = ({ date, format = 'MM/DD/YYYY', type }: any) => {
    let formatDate = '';
    if (date) {
        formatDate = moment(date).format(format);
    }
    return formatDate;
}

export const setDateHelper = ({ date, format = 'YYYY-MM-DD' }: any) => {
    let formatDate: any = '';
    if (date && moment(date, format, true).isValid()) {
        formatDate = moment(date).startOf('day').format(format);
        // formatDate = moment(date).startOf('day').toDate();
    }
    return formatDate;
}

// export const setDateHelperTZ = ({ date, format = 'YYYY-MM-DD' }: any) => {
//     let formatDate:any = '';

//     if (date && moment(date, format, true).isValid()) {
//         // handleStartDate(moment(date).startOf('day').toDate());

//         formatDate = moment(date).startOf('day').toDate();
//         console.log('formatDate =>>>>>>>>>>>>>>>.. ',formatDate)
//     }
//     return formatDate;
// }


export const reverseTimerHelper = (time: any, callback: any) => {
    const intervalId = setInterval(() => {
        time--;
        if (time <= 0) {
            clearInterval(intervalId);
        }
        callback(time);
    }, 1000);
    return intervalId;
};

export const maskEmail = (email: string): string => {
    const [username, domain] = email.split('@');
    if (username.length > 5) {
        const maskedUsername = `${username.substring(0, 3)}${'*'.repeat(username.length - 4)}${username.charAt(username.length - 1)}`;
        return `${maskedUsername}@${domain}`;
    }
    const maskedUsername = `${username.charAt(0)}${'*'.repeat(username.length - 2)}${username.charAt(username.length - 1)}`;
    return `${maskedUsername}@${domain}`;
};


export const getLastURL = (pathname: any) => {
    let lastURL = pathname && pathname?.split('/') && pathname?.split('/').pop();
    return lastURL;
}

export const userDetails = () => {
    const user_detail = getFromStorage({ key: StorageConstants?.USER_DETAIL });
    return user_detail
}




export const validateImage = (file: File, validImageTypes: string[]): string | true => {
    if (file) {
        const fileType = file.type.toLowerCase();
        const extension = file.name.split('.').pop()?.toLowerCase();

        // Check file type or extension
        if ((!fileType && !validImageTypes.includes(`image/${extension}`)) ||
            (fileType && !validImageTypes.includes(fileType))) {
            return "File format does not support";
        }

        // Check file size (5 MB in bytes)
        if (file.size > 5242880) {
            return "Image size must be below 5 MB";
        }
    }
    return true;
};


export const validImageTypes = ["jpeg", "png", "jpg", "webp", "JPEG", "PNG", "JPG", "WEBP", "image/jpeg", "image/png", "image/jpg", "image/webp", "image/JPEG", "image/PNG", "image/JPG", "image/WEBP"];

export const getPriceHelper = (price: number | string) => {
    if (price === undefined || price === null || price === '') {
        return '$0.00';
    }

    const roundedPrice =
        typeof price === 'number'
            ? Number(price.toFixed(2))
            : Number(Number(price).toFixed(2));

    return roundedPrice.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};


export const setDateTimeHelper = ({ date, format = 'MM/DD/YYYY', timeFormat = 'HH:mm' }: any) => {
    let formattedDateTime = '';

    if (date && moment(date).isValid()) {
        const formattedDate = moment(date).format(format);
        const formattedTime = moment(date).format(timeFormat);
        formattedDateTime = `${formattedDate} ${formattedTime}`;
    }

    return formattedDateTime;
}

export const getDatesDiffHelper = ({ date1, date2 }: any) => {
    let differenceInDays = 0;

    if (date1 && moment(date1, 'YYYY-MM-DD', true).isValid()) {
        const secondDate = date2 && moment(date2, 'YYYY-MM-DD', true).isValid()
            ? moment(date2, 'YYYY-MM-DD')
            : moment().startOf('day');

        const firstDate = moment(date1, 'YYYY-MM-DD').startOf('day');

        differenceInDays = secondDate.diff(firstDate, 'days');
    }

    return differenceInDays;
};

export const getFrequencyValue = ({ type, sDate, eDate }: {
    type: string | number,
    sDate: string | Date,
    eDate: string | Date,
}) => {
    const frequencyValues: { label: number, value: number }[] = [];
    const startDate = moment(sDate, 'YYYY-MM-DD');
    const endDate = moment(eDate, 'YYYY-MM-DD');

    for (let i = 1; i <= 5 + 1; i++) {
        frequencyValues.push({ label: i, value: i });
    }
    return frequencyValues;
    // if (!startDate.isValid() || !endDate.isValid()) return [];

    // switch (Number(type)) {
    //     case FREQUENCY_TYPES.DAILY:
    //         const diffInDays = moment(eDate).diff(moment(sDate), 'days');
    //         for (let i = 1; i <= diffInDays + 1; i++) {
    //             frequencyValues.push({ label: i, value: i });
    //         }
    //         break;

    //     case FREQUENCY_TYPES.WEEKLY:
    //         for (let i = 1; i <= 7; i++) {
    //             frequencyValues.push({ label: i, value: i });
    //         }
    //         break;

    //     case FREQUENCY_TYPES.MONTHLY:
    //         for (let i = 1; i <= 31; i++) {
    //             frequencyValues.push({ label: i, value: i });
    //         }
    //         break;

    //     case FREQUENCY_TYPES.YEARLY:
    //         for (let i = 1; i <= 12; i++) {
    //             frequencyValues.push({ label: i, value: i });
    //         }
    //         break;
    //     default:
    //         return [];
    // }
    // return frequencyValues;
}

// export const getChoresDiffrence = ({
//     date1,
//     date2,
//     frequencyType,
//     frequencyValue,
//     selectedDays, // New parameter for selected days (only for weekly)
// }: {
//     date1: string | Date;
//     date2: string | Date;
//     frequencyType: number | string;
//     frequencyValue: number | string;
//     selectedDays?: number[]; // Array of weekdays as numbers (0 = Sunday, 1 = Monday, ..., 6 = Saturday)
// }) => {
//     const startDate = moment(date1, 'YYYY-MM-DD');
//     const endDate = moment(date2, 'YYYY-MM-DD');

//     if (!startDate.isValid() || !endDate.isValid()) return [];

//     const resultDates = [];
//     let unit;

//     switch (Number(frequencyType)) {
//         case FREQUENCY_TYPES.DAILY:
//             unit = 'days';
//             break;
//         case FREQUENCY_TYPES.WEEKLY:
//             unit = 'weeks';
//             break;
//         case FREQUENCY_TYPES.MONTHLY:
//             unit = 'months';
//             break;
//         case FREQUENCY_TYPES.YEARLY:
//             unit = 'years';
//             break;
//         default:
//             unit = 'days';
//             break;
//     }
//     console.log('unit------------->', unit);
//     console.log('selectedDays------------->', selectedDays);

//     if (frequencyType === FREQUENCY_TYPES.WEEKLY && selectedDays && selectedDays.length > 0) {
//         let currentDate: any = startDate.clone();
//         while (currentDate.isSameOrBefore(endDate)) {
//             selectedDays.forEach((dayOfWeek) => {
//                 const dayToAdd = currentDate.clone().day(dayOfWeek);
//                 if (dayToAdd.isSameOrAfter(startDate) && dayToAdd.isSameOrBefore(endDate)) {
//                     resultDates.push(dayToAdd.format('DD-MM-YYYY'));
//                 }
//             });
//             currentDate.add(frequencyValue, unit);
//         }
//     } else {
//         // for (let m = startDate; m.isSameOrBefore(endDate); m.add(frequencyValue, unit)) {
//         //     resultDates.push(m.format('DD-MM-YYYY'));
//         // }
//         for (let m: any = startDate; m.isSameOrBefore(endDate); m.add(frequencyValue, unit)) {
//             resultDates.push(m.format('YYYY-MM-DD'));
//         }
//     }


//     return resultDates;
// };


export const getChoresDiffrence = ({
    date1,
    date2,
    frequencyType,
    frequencyValue,
    selectedDays,
}: {
    date1: string | Date;
    date2: string | Date;
    frequencyType: number | string;
    frequencyValue: number | string;
    selectedDays?: number[];
}) => {
    const startDate = moment(date1, 'YYYY-MM-DD');
    const endDate = moment(date2, 'YYYY-MM-DD');

    if (!startDate.isValid() || !endDate.isValid()) return [];
    const resultDates = [];
    const selectedDaysNumbers = selectedDays ? selectedDays.map(day => Number(day)) : [];

    if (frequencyType == FREQUENCY_TYPES.WEEKLY && selectedDaysNumbers.length > 0) {
        let currentDate = startDate.clone();
        while (currentDate.isSameOrBefore(endDate)) {
            for (const dayOfWeek of selectedDaysNumbers) {
                let nextDate = currentDate.clone().day(dayOfWeek);
                if (nextDate.isBefore(startDate)) {
                    nextDate.add(1, 'week');
                }
                if (nextDate.isSameOrAfter(startDate) && nextDate.isSameOrBefore(endDate)) {
                    resultDates.push(nextDate.format('YYYY-MM-DD'));
                }
            }
            currentDate.add(frequencyValue, 'week');
        }
    } else {
        let unit;
        switch (Number(frequencyType)) {
            case FREQUENCY_TYPES.DAILY:
                unit = 'days';
                break;
            case FREQUENCY_TYPES.MONTHLY:
                unit = 'months';
                break;
            case FREQUENCY_TYPES.YEARLY:
                unit = 'years';
                break;
            case FREQUENCY_TYPES.ONCE_ONLY:
            default:
                resultDates.push(startDate.format('YYYY-MM-DD'));
                return resultDates;
        }

        for (let m: any = startDate; m.isSameOrBefore(endDate); m.add(frequencyValue, unit)) {
            resultDates.push(m.format('YYYY-MM-DD'));
        }
    }

    return resultDates;

};



export const getFrequencyDates = (s_date: string, e_date: string, f_type: number, f_value: number, s_days_or_months: number[]) => {
    const startDate = moment(s_date, "YYYY-MM-DD");
    const endDate = moment(e_date, "YYYY-MM-DD");

    if (!startDate.isValid() || !endDate.isValid()) {
        console.error("Invalid date format. Use 'YYYY-MM-DD'.");
        return [];
    }
    let currentDate = moment(startDate);
    const resultDates: string[] = [];
    const addIfWithinRange = (date: moment.Moment) => {
        if (date.isSameOrBefore(endDate)) {
            resultDates.push(date.format('YYYY-MM-DD'));
        }
    };
    if (f_type === FREQUENCY_TYPES.ONCE_ONLY) {
        addIfWithinRange(currentDate);
    }
    else if (f_type === FREQUENCY_TYPES.DAILY) {
        while (currentDate.isSameOrBefore(endDate)) {
            addIfWithinRange(currentDate);
            currentDate.add(f_value, 'days');
        }
    } else if (f_type === FREQUENCY_TYPES.WEEKLY) {
        while (currentDate.isSameOrBefore(endDate)) {
            for (let i = 0; i < 7; i++) {
                if (s_days_or_months.includes(currentDate.day())) {
                    addIfWithinRange(currentDate);
                }
                currentDate.add(1, 'day');
            }
            currentDate.add((f_value - 1) * 7, 'days');
        }
    } else if (f_type === FREQUENCY_TYPES.MONTHLY) {

        while (currentDate.isSameOrBefore(endDate)) {
            const currentMonth = currentDate.month(); // 0-11
            // Check if current month is in the selected months
            if (s_days_or_months.includes(currentMonth)) {
                addIfWithinRange(currentDate);
            }
            // Move to next occurrence (f_value months later)
            currentDate.add(f_value, 'months');
        }
        // while (currentDate.isSameOrBefore(endDate)) {
        //     for (const month of s_days_or_months) {
        //         const dateToCheck = moment({ year: currentDate.year(), month: month, day: 1 });
        //         if (dateToCheck.isSameOrAfter(startDate) && dateToCheck.isSameOrBefore(endDate)) {
        //             addIfWithinRange(dateToCheck);
        //         }
        //     }
        //     currentDate.add(f_value, 'years');
        // }

        // while (currentDate.isSameOrBefore(endDate)) {
        //     const currentYear = currentDate.year();
        //     for (const month of s_days_or_months) {
        //         const dateToCheck = moment({ year: currentYear, month: month, day: 1 });
        //         addIfWithinRange(dateToCheck);
        //     }
        //     currentDate.add(f_value, 'years');
        // }
    }

    return resultDates;
}

export const getMemberType = (type: 0 | 1 | 2 | 3) => {
    return HOUSEHOLD_TYPES_NAME[type]
}

export const minutesToHour = (minutes: string | number) => {
    if (minutes) {
        let minute = (Number(minutes) % 60).toString().padStart(2, '0');
        return String(Number(minutes) / 60).split('.')[0] + '.' + minute;
    } else return 0;
}



export const isDateFinalized = (date: string, finalizedMonths: Array<{ s_date: string; e_date: string }>) => {
    return finalizedMonths.some(month => {
        const start = moment(month.s_date).startOf('day');
        const end = moment(month.e_date).endOf('day');
        const currentDate = moment(date).startOf('day');
        return currentDate.isBetween(start, end, undefined, '[]');
    });
};

export const isDateRangeFinalized = (
    s_date: string,
    e_date: string,
    finalizedMonths: Array<{ s_date: string; e_date: string }>
) => {
    const start = moment(s_date).startOf('day');
    const end = moment(e_date).endOf('day');

    return finalizedMonths.some(month => {
        const finalizedStart = moment(month.s_date).startOf('day');
        const finalizedEnd = moment(month.e_date).endOf('day');
        return (
            start.isBetween(finalizedStart, finalizedEnd, undefined, '[]') ||
            end.isBetween(finalizedStart, finalizedEnd, undefined, '[]') ||
            finalizedStart.isBetween(start, end, undefined, '[]') ||
            finalizedEnd.isBetween(start, end, undefined, '[]')
        );
    });
};

export const checkPermission = (plan_perms: string[], slug: string) => {
    return plan_perms?.includes(slug);
}

export const hasAnySubscription = (profile: any) => {
    if (profile?.is_free_plan && profile?.is_free_plan_cancel) {
        return false;
    }
    return !!(
        profile?.is_premium ||
        profile?.is_free_plan ||
        profile?.is_household_premium ||
        profile?.is_free ||
        profile?.is_free_trial ||
        profile?.is_trial ||
        profile?.subscription_status === 'active'
    );
}

export const formatNumber = (value: any) => {
    if (value % 1 !== 0) {
        return value.toFixed(2);
    } else {
        return `${value}.00`;
    }
}

export function generateUniqueId(prefix = 'id') {
    return `${prefix}-${Math.random().toString(36).substr(2, 9)}-${Date.now()}`;
}

export const getPricingType = (type: string) => {
    if (type == 'task_based') {
        return "Task-based"
    } else if (type == 'task_neutral') {
        return "Task-neutral"
    }
    return ""
}

export const PAYMENT_METHOD = [
    { value: "1", label: "Bank Transfer" },
    { value: "2", label: "Cash" },
    { value: "3", label: "Check" },
    { value: "4", label: "Credit Card" },
    { value: "5", label: "Debit Card" },
    { value: "6", label: "Digital Wallet" },
    { value: "7", label: "Payment App" },
];

export const getBudgetPeriodDates = (year: number, month: number, billingDay: number) => {
    const targetBillingDay = Number(billingDay) || 1;
    const daysInMonth = moment({ year, month }).daysInMonth();
    const cappedBillingDay = Math.min(targetBillingDay, daysInMonth);
    const startDate = moment({ year, month, day: cappedBillingDay }).startOf('day');

    const nextMonthMoment = moment({ year, month }).add(1, 'month');
    const nextYear = nextMonthMoment.year();
    const nextMonth = nextMonthMoment.month();
    const daysInNextMonth = nextMonthMoment.daysInMonth();
    const cappedNextBillingDay = Math.min(targetBillingDay, daysInNextMonth);
    const nextStartDate = moment({ year: nextYear, month: nextMonth, day: cappedNextBillingDay }).startOf('day');

    const endDate = nextStartDate.clone().subtract(1, 'day');

    return {
        startDate: startDate.format('YYYY-MM-DD'),
        endDate: endDate.format('YYYY-MM-DD'),
    };
}; 